// extracted by mini-css-extract-plugin
export default {"accordion":"CustomRadios_accordion__1smfg"};